module.exports = __webpack_public_path__ + "media/images/banner02-404fd9e4345e34ceec2ecc0e138ac824.webp";